import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, timeout } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Chimie {
  id: number;
  nom: string;
}

export interface ChimiePayload {
  nom: string;
}

@Injectable({ providedIn: 'root' })
export class ChimieService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/chimie`;
  private readonly requestTimeoutMs = 30000;

  constructor(private readonly http: HttpClient) {}

  list(): Observable<Chimie[]> {
    return this.http
      .get<{ items?: Chimie[] } | Chimie[]>(this.baseUrl)
      .pipe(
        timeout(this.requestTimeoutMs),
        map((response) => {
          if (Array.isArray(response)) {
            return response;
          }
          return Array.isArray(response?.items) ? response.items : [];
        })
      );
  }

  get(id: number): Observable<Chimie> {
    return this.http
      .get<Chimie>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }

  create(payload: ChimiePayload): Observable<Chimie> {
    return this.http
      .post<Chimie>(this.baseUrl, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  update(id: number, payload: ChimiePayload): Observable<Chimie> {
    return this.http
      .put<Chimie>(`${this.baseUrl}/${id}`, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  delete(id: number): Observable<{ deleted: boolean; id: number }> {
    return this.http
      .delete<{ deleted: boolean; id: number }>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }
}
